import React from 'react';
import { Paper, Typography } from '@mui/material';
import { useTranslatedMessages } from '../../../../hooks/useTranslatedMessages';

const IntraCompanyTab = () => {
  const { misDashboard: m } = useTranslatedMessages();

  return (
    <Paper variant="outlined" sx={{ p: 3, borderRadius: 2 }}>
      <Typography color="text.secondary">
        {m.intra_company?.coming_soon ??
          'Intra-company analytics will appear here once the analytics APIs are available.'}
      </Typography>
    </Paper>
  );
};

export default IntraCompanyTab;
